import { createReducer } from '@reduxjs/toolkit'

import { DATES } from 'const/filters'
import { LOCAL_FILTERS, FILTER_SETTINGS } from 'const/reducerKeys'

import { defaultPage } from '../defaults'

const defaultState = {
    [LOCAL_FILTERS]: {},
    [FILTER_SETTINGS]: {
        anchored: [DATES],
        order: [],
        displayState: {},
    },

    ...defaultPage,
}

export default createReducer(defaultState, () => {})
